export { FavoriteStoreIconContainer as FavoriteStoreIcon } from './favorite-store-icon.container';
